(function () {
  // --- Google Ads conversion (voucher claim) ---
  var GADS_ID = 'AW-18338618074';
  var GADS_SEND_TO = 'AW-18338618074/cgBWCJzAxOYcENq1xKhE';
  // Phrases that appear in the UpForm success message once a claim succeeds.
  var VOUCHER_SUCCESS_SIGNS = ['voucher request has been received', 'voucher code has been sent'];

  function pushEvent(root, eventName, extra) {
    var payload = {
      event: eventName,
      campaign_store: (root && root.getAttribute('data-db-store')) || 'unknown',
      landing_page_id: (root && root.getAttribute('data-db-page-id')) || 'unknown'
    };
    if (extra) { for (var k in extra) { if (Object.prototype.hasOwnProperty.call(extra, k)) payload[k] = extra[k]; } }
    if (root) root.setAttribute('data-db-last-event', eventName);
    window.drBoomAnalyticsQueue = window.drBoomAnalyticsQueue || [];
    window.drBoomAnalyticsQueue.push(payload);
    if (Array.isArray(window.dataLayer)) window.dataLayer.push(payload);
  }

  // Load the Google Ads tag (gtag.js) once, on these landing pages only.
  function ensureGtag() {
    if (window.__dbGtagLoaded) return;
    window.__dbGtagLoaded = true;
    window.dataLayer = window.dataLayer || [];
    if (typeof window.gtag !== 'function') {
      window.gtag = function () { window.dataLayer.push(arguments); };
    }
    var s = document.createElement('script');
    s.async = true;
    s.src = 'https://www.googletagmanager.com/gtag/js?id=' + GADS_ID;
    document.head.appendChild(s);
    window.gtag('js', new Date());
    window.gtag('config', GADS_ID);
  }

  // Fire the voucher-claim conversion exactly once per page load.
  function fireVoucherClaim() {
    if (window.__dbVoucherClaimFired) return;
    window.__dbVoucherClaimFired = true;
    ensureGtag();
    try { window.gtag('event', 'conversion', { 'send_to': GADS_SEND_TO }); } catch (e) {}
    pushEvent(document.querySelector('[data-db-landing]'), 'voucher_claim');
    if (window.console && window.console.log) window.console.log('[DrBoom] voucher_claim conversion fired');
  }

  function textHasSuccess(text) {
    if (!text) return false;
    var t = ('' + text).toLowerCase();
    for (var i = 0; i < VOUCHER_SUCCESS_SIGNS.length; i++) {
      if (t.indexOf(VOUCHER_SUCCESS_SIGNS[i]) !== -1) return true;
    }
    return false;
  }

  // Watch for the UpForm success message appearing (no page reload).
  function watchForVoucherSuccess() {
    if (window.__dbVoucherWatchBound || !('MutationObserver' in window) || !document.body) return;
    window.__dbVoucherWatchBound = true;
    var obs = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var added = mutations[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var node = added[j];
          var text = node.nodeType === 1 ? node.textContent : (node.nodeType === 3 ? node.nodeValue : '');
          if (textHasSuccess(text)) { fireVoucherClaim(); obs.disconnect(); return; }
        }
      }
    });
    obs.observe(document.body, { childList: true, subtree: true });
  }

  function initStoreLandingTracking() {
    ensureGtag();            // load the Google tag so the conversion can fire instantly
    watchForVoucherSuccess(); // start watching for the claim success message

    var roots = document.querySelectorAll('[data-db-landing]');
    roots.forEach(function (root) {
      if (root.getAttribute('data-db-tracking-bound') === 'true') return;
      root.setAttribute('data-db-tracking-bound', 'true');

      pushEvent(root, 'landing_page_view');

      var trackedTargets = root.querySelectorAll('[data-db-event]');
      root.setAttribute('data-db-event-count', String(trackedTargets.length));
      trackedTargets.forEach(function (target) {
        target.addEventListener('click', function () {
          pushEvent(root, target.getAttribute('data-db-event'));
        });
      });

      // Generic copy support: any [data-db-copy] button copies the text content
      // of the element referenced by its data-db-copy value (or the closest
      // [data-db-code]) and fires voucher_copy. No code value is sent to analytics.
      root.addEventListener('click', function (e) {
        var btn = e.target && e.target.closest ? e.target.closest('[data-db-copy]') : null;
        if (!btn) return;
        var sel = btn.getAttribute('data-db-copy');
        var codeEl = (sel && document.querySelector(sel)) || root.querySelector('[data-db-code]');
        if (!codeEl) return;
        var text = (codeEl.textContent || '').trim();
        if (!text) return;
        var done = function () { pushEvent(root, 'voucher_copy'); };
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(text).then(done, done);
        } else {
          var ta = document.createElement('textarea');
          ta.value = text; document.body.appendChild(ta); ta.select();
          try { document.execCommand('copy'); } catch (err) {}
          document.body.removeChild(ta); done();
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initStoreLandingTracking);
  } else {
    initStoreLandingTracking();
  }

  function resetInitialScroll() {
    if (window.location.hash) return;
    if ('scrollRestoration' in window.history) window.history.scrollRestoration = 'manual';
    window.scrollTo(0, 0);
    window.requestAnimationFrame(function () { window.scrollTo(0, 0); });
  }
  window.addEventListener('pageshow', resetInitialScroll);
  resetInitialScroll();
}());